import { t as translate } from 'i18next';

const t = (key: string, params: Record<string, unknown> = {}) =>
	translate(`forgotPassword:${key}`, params);

export const validatePassword = (value: string) => {
	// Check if the password is at least 8 characters long
	if (!value || value.length < 8) {
		return t('minLength', { module: 'password', num: 8 });
	}
	// Check if the password contains at least one uppercase and one lowercase letter
	if (!/[A-Z]/.test(value) || !/[a-z]/.test(value)) {
		return t('uppercaseLowercase');
	}
	// Check if the password contains at least one symbol
	if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
		return t('symbol');
	}
	// Check if the password contains at least one number
	if (!/\d/.test(value)) {
		return t('number');
	}
	// If all checks pass, return true
	return true;
};
